// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MultiSelectFilter-list__iPCfH.MultiSelectFilter-list__iPCfH{box-shadow:var(--box-shadow-sm-up)}@media only screen and (min-width: 64rem){.MultiSelectFilter-list__iPCfH.MultiSelectFilter-list__iPCfH{width:-moz-max-content;width:max-content;max-width:min(var(--size-96),var(--radix-popper-available-width, var(--size-96)));box-shadow:var(--box-shadow-sm-down)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "MultiSelectFilter-list__iPCfH"
};
export default ___CSS_LOADER_EXPORT___;
